
import Icon from "../element/icon.vue";
import ScrollUp from "../component/scroll-up.vue";

const u = {

  applyViewport (){
    let el = document.querySelector("meta[name=viewport]");
    if(this.isTablet()){
      el.setAttribute("content", "width=1200,user-scalable=no");
    }
  },

  applyScrollUp (){
    const el = document.querySelector(".c-scroll-up");
    if(el){
      new Vue({
        el: el,
        components: {
          "scroll-up": ScrollUp
        },
        template: '<scroll-up></scroll-up>'
      });
    }
  },

  applyIcons (sel){
    const els = document.querySelectorAll(sel);
    Array.from(els).map((el) => {
      const name = el.getAttribute("data-name");
      if(! name) return;
      new Vue({
        el: el,
        components: {
          "icon": Icon
        },
        template: `<icon name="${name}"></icon>`
      });
    })
  },

  applyAnchorActions (){
    // const paddingTop = parseInt($("body").css("padding-top"), 10);
    const paddingTop = 65;
    $(document).on("click", "a", (e) => {
      const el = e.currentTarget;
      const m = el.getAttribute("href").match(/^#-(.+)$/)
      if(!! m){
        e.preventDefault();
        const dest = $(`[data-anchor=${m[1]}]`);
        if(dest.length){
          $("html,body").animate({
            scrollTop: dest.offset().top - paddingTop
          }, 300);
        }
      }
      if(el.hostname !== location.hostname){
        el.target = "_blank";
      }
    });
  },

  handleSpMenu (){
    const el = document.querySelector(".c-header__sp-menu");
    const toggle = document.getElementById("spmenu-toggle");
    el.addEventListener("click", (e) => {
      if(e.target === el){
        toggle.checked = false;
      }
    })
  },

  isEmail (value){
    return (/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/).test(value);
  },

  isTablet (){
    return window.ontouchstart !== void 0 && screen.width > 640 && screen.width < 1024;
  },

  escape (html){
    let el = document.createElement("i");
    let text = document.createTextNode(html);
    el.appendChild(text);
    return el.innerHTML;
  },

  exists (obj, prop){
    return (!!obj && (prop in obj)) ? obj[prop] : void 0;
  },

  trim (str){
    return str.replace(/(^\s+|\s+$)/g, "");
  },

  parseSrcset (img){
    if(! img.srcset){
      return img.src;
    }
    let width = $(window).width();
    if(this.isTablet()){
      width = 1200;
    }
    let src = img.src;
    let list = img.srcset.split(",").map((item) => {

      item = this.trim(item).split(" ");
      return {
        width: parseInt(item[1], 10),
        src: this.trim(item[0])
      }
    });
    list.reverse().map((item) => {
      if(width <= item.width){
        src = item.src;
      }
    });

    return src;
  },

  getNext (value, list){
    let dest = null;
    for(let i=0; i<list.length; i++){
      if(! dest && value < list[i]) {
        dest = list[i];
      }
    }
    return dest;
  },

  getPrev (value, list){
    let i = list.length;
    let dest = null;
    while(i--){
      if(!dest && value > list[i]){
        dest = list[i];
      }
    }
    return dest;
  }
};

export default u;



// WEBPACK FOOTER //
// ./src/lib/u.js